<template>
  <b-card class="mt-2">
    <div
      class="d-flex justify-content-between"
    >
      <span class="d-flex align-items-center mb-50">
        <span class="chart-title">{{ title }}</span>
        <GjIcon
          v-if="title === 'Actions'"
          v-b-tooltip.hover="$tk('ClientPortal.Forecasting.OnlyVideoAdCanPredictActions')"
          class="ml-25"
          name="Info"
        />
      </span>
    </div>
    <div class="d-flex justify-content-between">
      <apexcharts
        height="280"
        type="pie"
        width="300px"
        :series="chartData.pieChart.series"
        :options="pieChartOptions"
      />
      <apexcharts
        class="w-100"
        height="280"
        type="line"
        :series="chartData.lineChart.series"
        :options="chartOptions"
      />
    </div>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { computed } from '@vue/composition-api'

export default {
  components: {
    apexcharts: VueApexCharts,
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    chartData: {
      type: [Array, Object],
    },
    // eslint-disable-next-line vue/require-default-prop
    title: {
      type: [String],
    },
    colors: {
      type: [Array],
      default() {
        return ['#FFBF68', '#506C91', '#99A6B9']
      },
    },
  },
  setup(props) {
    const getFileName = () => {
      const currentDateTime = new Date()
      const dateTime = `${currentDateTime.getFullYear()}/${currentDateTime.getMonth() + 1}/${currentDateTime.getDate()}`
      return `${props.title} - ${dateTime}`
    }
    const pieChartOptions = computed(() => ({
      chart: {
        type: 'pie',
        toolbar: { show: false },
      },
      dataLabels: {
        enabled: false,
      },
      yaxis: {
        decimalsInFloat: 2,
        labels: {
          formatter(value) {
            return `${value.toFixed(2).toLocaleString()}%`
          },
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        labels: {
          colors: '#031C3C',
        },
        fontWeight: 500,
      },
      colors: props.colors,
      labels: props.chartData.pieChart.labels,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      }],
    }))

    const chartOptions = computed(() => ({
      chart: {
        shadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 1,
        },
        toolbar: {
          show: true,
          offsetX: -20,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: [],
          },
          export: {
            csv: {
              filename: getFileName(),
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString()
              },
            },
            png: {
              filename: getFileName(),
            },
          },
        },
      },
      colors: props.colors,
      dataLabels: {
        enabled: true,
        formatter(val) {
          return val.toLocaleString()
        },
      },
      stroke: {
        curve: 'smooth',
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
        padding: {
          left: 30,
          right: 0,
        },
      },
      markers: {
        size: 5,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: props.chartData.lineChart.xAxisLabels,
      },
      yaxis: {
        decimalsInFloat: 2,
        labels: {
          formatter(value) {
            return value.toLocaleString()
          },
          offsetX: -10,
          align: 'left',
        },
      },
    }))

    return {
      pieChartOptions,
      chartOptions,
    }
  },
}
</script>

<style>
.chart-title{
  font-size: 20px;
  line-height: 30px;
  color: #031C3C;
  font-weight: bold;
}
.apexcharts-menu-item.exportSVG {
  display: none;
}
.apexcharts-toolbar {
  z-index: 0;
}
</style>
